import { handleActions, combineActions } from 'redux-actions';
import {  Map,fromJS } from 'immutable';

import actions from '@synergycms_app/store/actions';


//REDUCERS
const {
  app: appActions
} = actions;

const app = handleActions(
  {
    [appActions.name.get.toString()]: (app, { payload }) => {
      return app.set("name", payload);
    },
    [appActions.outerWeb.get.toString()]: (app, { payload }) => {
      return app.set("outer_web", payload);
    },
    [combineActions(appActions.config.get.toString(), appActions.config.getAsync.toString())]: (app, { payload }) => {
      if (payload) {        
        return app.set("config", fromJS(payload));
      }
    },
    [combineActions(appActions.config.getHotel.toString(), appActions.config.getHotelAsync.toString())]: (app, { payload }) => {
      if (payload) {
        return app.set("hotelConfig", app.get("hotelConfig", Map()).merge(fromJS(payload)));
      }
    }
  },
  Map()
);


export default app;
